import { ArrowRightAlt } from "@mui/icons-material";
import { Link } from "react-router-dom";

import { Stack, Box, Grid } from "@mui/material";
import './HomeScreen.css';
import ImageBox from "../common/ImageBox"
import homeimg from '../common/images/homeimg.jpg'

function HomeScreen() {    

    return(
        <Box sx={{ width:'97%', flexGrow:1, p:2}}>
            <Stack spacing={5}>
                <Box sx={{  height:'60% !important', borderRadius:'10px', margin:'20px'}}>
                <ImageBox  myclass="homeclass" imageUrl={homeimg}></ImageBox>
                </Box>
                <Grid container style={{marginTop:"25px"}} sx={{ "& .MuiGrid-container":{marginTop:"25px"}, alignContent:'space-evenly', display:'flex', flexDirection:'row', justifyContent:'center'}}  >
                    <Grid item xs={3} >
                        <Box className="home-links" alignItems="center" display="flex" spacing={2}>
                            
                            <span className="link-header">Enrollment</span>
                            {/* <p>This form is for enrolling new residents into the Care Facility and updating existing residents.</p> */}
                            <p>Click the link to view enrolled residents and adding/updating resident information.</p>
                            <div style={{ display:'flex', flexDirection:'row'}}><Link to="/directDepositListing">Enrollment List</Link><ArrowRightAlt  sx={{ color:'#002d82'}} /></div>
                        </Box>
                    </Grid>
                    <Grid  item xs={3}>
                        <Box className="home-links" alignItems="center" display="flex" spacing={2}>
                            
                            <span className="link-header">Resident Status</span>
                            <p>Click the link to view residents status list and change resident status.</p>
                            <div style={{ display:'flex', flexDirection:'row'}}><Link to="/residentListings">Resident Status List</Link><ArrowRightAlt  sx={{ color:'#002d82'}} /></div>
                        </Box>
                    </Grid>
                    <Grid item xs={3}>
                        <Box className="home-links" alignItems="center" display="flex" spacing={2}>
                            
                            <span className="link-header">Update Allowance</span>
                            <p>Click the link to view allowance list and update allowance for enrolled residents.</p>
                            <div style={{ display:'flex', flexDirection:'row'}}><Link to="/allowanceListings">Allowance Update List</Link><ArrowRightAlt  sx={{ color:'#002d82'}} /></div>
                        </Box>
                    </Grid>
                </Grid>
            </Stack>
        </Box>
    );

}

export default HomeScreen;